<template>
    <div v-if="active" class="transmission alert bg-muted p-sm" :class="transmissionClass">
        <div class="progress-striped">
            <div style="width:100%;"
                 role="progressbar"
                 class="progress-bar active"
                 aria-valuemax="100"
                 aria-valuemin="0"
                 :aria-valuenow="100">
                <span>{{ t_active_transmissions }}: {{ transmissions }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            nudge: Boolean
        },
        data: function () {
            return {
                t_active_transmissions: Lang.langGet("Active Transmissions"),
                active: false,
                transmissions: 0
            }
        },
        computed: {
            transmissionClass() {
                return this.nudge ? 'transmission-bottom-nudged' : 'transmission-bottom';
            }
        },
        methods: {
            doTransmissionChecks: function () {
                axios.post('/content/publish/transmission', {
                    project_id: Laravel.activeProject
                }).then((response) => {
                    this.transmissions = parseInt(response.data.data);
                    this.active = this.transmissions > 0;
                }).catch((error) => {
                    if (error.response?.status === 401) {
                        window.location = '/login';
                    }

                    this.active = false;
                });
            }
        },
        mounted() {
            this.doTransmissionChecks();

            setInterval(() => {
                this.doTransmissionChecks();
            }, 3000); // check every 3 seconds
        }
    }
</script>

<style>
    .progress-striped > .progress-bar {
        background-repeat: repeat-x !important;
    }

    .transmission {
        z-index: 2210;
        position: fixed;
        right: 10px;
        width: 200px;
        border-radius: 5px;
        background-color: #dbdbdb;
        border: 1px solid #b1b1b1;
        box-shadow: 1px 1px 5px #919191;
    }

    .transmission-bottom-nudged {
        bottom: 60px;
    }

    .transmission-bottom {
        bottom: 20px;
    }
</style>
